import $ from "jquery";
import Foundation from "./3rd/_zf.js";

import "./utils/global.js";
import "./utils/back-to-top.js";
import "./utils/script-loader.js";
import { initMenu } from "./utils/menu.js";

import { initSocialShare } from "./components/social-share.js";

// Styles
import "../styles/3rd/_index.scss";

// DOMContentLoaded
document.addEventListener("DOMContentLoaded", () => {
  initMenu("nav.nav", ".main-nav");
  initSocialShare("[data-social-share]", {
    intents: ["facebook", "x", "print", "send-email", "copy-link", "web-share"],
  });

  //
  // toggle menu footer
  //
  document.querySelectorAll("#footer-columns .footer-title").forEach((link) => {
    link.addEventListener("click", function (event) {
      event.preventDefault();
      this.classList.toggle("active");
    });
  });

  //
  // product attributes
  //
  const MIN_WIDTH = 250;
  const widgets = document.querySelectorAll(
    ".product-attributes .widget_layered_nav"
  );

  function adjustDropdown(widget) {
    const dropdown = widget.querySelector("ul");
    if (!dropdown) return;

    const toggleElem = widget.querySelector("span") || widget;
    const rect = toggleElem.getBoundingClientRect();
    const spaceRight = window.innerWidth - rect.right;

    if (spaceRight < MIN_WIDTH) {
      dropdown.classList.add("align-right");
    } else {
      dropdown.classList.remove("align-right");
    }
  }

  function closeAll() {
    widgets.forEach((el) => el.classList.remove("active"));
  }

  widgets.forEach((widget) => {
    widget.addEventListener("click", (e) => {
      if (e.target.closest("ul")) return;

      e.preventDefault();
      const isActive = widget.classList.contains("active");

      closeAll();

      if (!isActive) {
        widget.classList.add("active");
        adjustDropdown(widget);
      }
    });
  });

  window.addEventListener("resize", () => {
    const openWidget = document.querySelector(
      ".product-attributes .widget_layered_nav.active"
    );
    if (openWidget) adjustDropdown(openWidget);
  });
});

const observer = new MutationObserver(function (mutations, obs) {
  const emptyCartTitle = document.querySelector(
    ".wc-block-cart__empty-cart__title"
  );
  if (emptyCartTitle) {
    emptyCartTitle.textContent = "Giỏ hàng của bạn đang trống!";
    obs.disconnect(); // Dừng theo dõi sau khi đã thay xong
  }
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("DOMContentLoaded", function () {
  const shareTitle = document.querySelector(".share-title");
  if (shareTitle) {
    shareTitle.textContent = "Chia sẻ";
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const tongQuanLinks = document.querySelectorAll(".tongquan_pro_detail");

  // Nếu là mobile thì thay đổi href
  if (window.innerWidth <= 768) {
    tongQuanLinks.forEach(function (link) {
      const href = link.getAttribute("href");
      if (href === "#lichtrinh") {
        link.setAttribute("href", "#lichtrinh-mobile");
      } else if (href === "#bando") {
        link.setAttribute("href", "#bando-mobile");
      } else if (href === "#luuy") {
        link.setAttribute("href", "#luuy-mobile");
      } else if (href === "#tongquan") {
        link.setAttribute("href", "#tongquan-mobile");
      }
    });
  }

  tongQuanLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      // Bỏ class active ở tất cả các thẻ
      tongQuanLinks.forEach(function (el) {
        el.classList.remove("active");
      });

      // Thêm class active vào thẻ được click
      this.classList.add("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const tongQuanLinks = document.querySelectorAll(".lichtrinhchitiet");

  tongQuanLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      this.classList.toggle("active");
    });
  });
});
document.addEventListener("DOMContentLoaded", function () {
  const thongtincanluuyLinks = document.querySelectorAll(".thongtincanluuy");

  thongtincanluuyLinks.forEach(function (link) {
    link.addEventListener("click", function (e) {
      this.classList.toggle("active");
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const icon_down = document.querySelectorAll(".icon_down");

  icon_down.forEach(function (link) {
    link.addEventListener("click", function (e) {
      this.parentElement.parentElement.classList.toggle("active");
    });
  });
});

window.addEventListener('scroll', function() {
    const header = document.querySelector('.masthead');
    if (window.scrollY > 80) {
        header.classList.add('fixed');
    } else {
        header.classList.remove('fixed');
    }
});